import {
  Breadcrumb,
  Button,
  Card,
  Col,
  Collapse,
  Form,
  Input,
  Layout,
  message,
  Row,
  Tag,
  Typography,
} from 'antd';
import React from 'react';
import ReactInputMask from 'react-input-mask';
import { Link, Navigate } from 'react-router-dom';
import { getToken, POST_API, POST_CATCH, titleWeb } from '../../services/api';
// CONTROLLER
import PageLoad from '../Controller/PageLoad';

class AdminAlterarPlanoCart extends React.Component {
  state = {
    _navigate: false,
    _buy: false,
    _loading: false,
    _screen: true,
    _dados: null,
    _params: window.location.href.split('/'),
    defaultValue: null,
    modal: false,
    title: '',
    type: '',
    type_select: '',
    id: '',
    plan: null,
    plan_select: null,
    my: null,
    result: null,
  };

  routes = [
    { title: <Link to="/painel/minhaconta">Minha conta</Link> },
    { title: <Link to="/painel/minhaconta/alterarplano">Alterar Plano</Link> },
  ];

  componentDidMount = () => {
    titleWeb('Alterar Plano');
    POST_API('/plan/onload.php', {
      token: getToken(),
      ID: this.state._params[6],
    })
      .then((rs) => rs.json())
      .then((res) => {
        if (res.return) {
          this.setState({ my: res.my });
        }
      });
    POST_API('/plan/search.php', {
      token: 'X',
      filter: JSON.stringify({ ID: this.state._params[6] }),
    })
      .then((rs) => rs.json())
      .then((res) => {
        if (res.return) {
          this.setState({ data: res.data[0], _screen: false });
        } else {
          message.warning({ content: res.msg, key: 'screen' });
        }
      })
      .catch(() => {
        message.error({
          content: 'Não foi possível estabelecer uma conexão com o sistema',
          key: 'screen',
        });
      });
  };

  onSend = (values) => {
    this.setState({ _loading: true });
    POST_API('/subscription/asaas.php', {
      token: getToken(),
      master: JSON.stringify(values),
      PLAN_ID: this.state._params[6],
      type: this.state._params[7],
    })
      .then((rs) => rs.json())
      .then((res) => {
        if (res.return) {
          message.success({ content: res.msg, key: 'screen' });
          this.setState({ _navigate: true });
        } else {
          message.warning({ content: res.msg, key: 'screen' });
        }
      })
      .catch(() => {
        POST_CATCH();
      })
      .finally(() => this.setState({ _loading: false }));
  };

  render = () => {
    if (this.state._navigate) {
      return <Navigate to={'/painel/minhaconta'} />;
    }

    return (
      <Layout>
        <Layout.Content className={'admin-container'}>
          <Row gutter={[8, 8]}>
            <Col span={18}>
              <Breadcrumb items={this.routes} />
            </Col>
            <Col
              span={6}
              style={{ display: 'flex', justifyContent: 'flex-end' }}
            />
            {this.state._screen ? (
              <PageLoad />
            ) : (
              <Col span={24}>
                <Row align={'top'} gutter={[8, 16]}>
                  <Col md={16} xs={24}>
                    <Card size="small" title="Plano">
                      <Row
                        align={'bottom'}
                        gutter={[8, 8]}
                        style={{ flexWrap: 'nowrap' }}
                      >
                        <Col flex={'auto'}>
                          <Typography className="text-new">
                            {this.state.data?.NAME}{' '}
                            <Tag color={'var(--primary)'}>
                              {this.state._params[7] === 'A'
                                ? 'Plano anual'
                                : 'Plano mensal'}
                            </Tag>
                          </Typography>
                          <Typography className="text-new-sub">
                            {this.state.data?.DESC}
                          </Typography>
                        </Col>
                        <Col flex={'260px'}>
                          {this.state.my?.ID > 1 && (
                            <Typography className="text-new-price-under">
                              <span>R$ </span>
                              {this.state._params[7] === 'A'
                                ? Number(
                                    this.state.data?.PRICE_YEAR
                                  ).toLocaleString('pt-br', {
                                    minimumFractionDigits: 2,
                                  })
                                : Number(
                                    this.state.data?.PRICE_MONTH
                                  ).toLocaleString('pt-br', {
                                    minimumFractionDigits: 2,
                                  })}
                            </Typography>
                          )}
                          <Typography className="text-new-price">
                            <span>R$ </span>
                            {this.state._params[7] === 'A'
                              ? Number(
                                  this.state.data?.PRICE_YEAR -
                                    (this.state.my?.TYPE_PLAN === 'M'
                                      ? this.state.my?.PRICE_MONTH
                                      : this.state.my?.PRICE_YEAR)
                                ).toLocaleString('pt-br', {
                                  minimumFractionDigits: 2,
                                })
                              : Number(
                                  this.state.data?.PRICE_MONTH -
                                    (this.state.my?.TYPE_PLAN === 'M'
                                      ? this.state.my?.PRICE_MONTH
                                      : this.state.my?.PRICE_YEAR)
                                ).toLocaleString('pt-br', {
                                  minimumFractionDigits: 2,
                                })}
                          </Typography>
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                  <Col md={8} xs={24}>
                    <Card size="small" title="Escolha uma forma de pagamento">
                      <Collapse accordion={true}>
                        <Collapse.Panel header="Cartão de crédito" key={0}>
                          <Form onFinish={this.onSend}>
                            <Row gutter={[8, 0]}>
                              <Form.Item
                                hidden
                                initialValue="CREDIT_CARD"
                                name="TYPE"
                              >
                                <Input value="CREDIT_CARD" />
                              </Form.Item>
                              <Col span={24}>
                                <Form.Item
                                  name={'NUMBER'}
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Campo obrigatório',
                                    },
                                  ]}
                                >
                                  <ReactInputMask
                                    mask={'9999 9999 9999 9999'}
                                    maskChar={''}
                                    maxLength={19}
                                    placeholder={'Número do cartão'}
                                  >
                                    {(props) => <Input {...props} />}
                                  </ReactInputMask>
                                </Form.Item>
                              </Col>
                              <Col span={24}>
                                <Form.Item
                                  name={'NAME'}
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Campo obrigatório',
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder={'Nome do titular'}
                                    size="large"
                                  />
                                </Form.Item>
                              </Col>
                              <Col span={14}>
                                <Form.Item
                                  name={'EXPIRY'}
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Campo obrigatório',
                                    },
                                  ]}
                                >
                                  <ReactInputMask
                                    mask={'99/99'}
                                    maskChar={''}
                                    maxLength={5}
                                    placeholder={'Validade'}
                                  >
                                    {(props) => <Input {...props} />}
                                  </ReactInputMask>
                                </Form.Item>
                              </Col>
                              <Col span={10}>
                                <Form.Item
                                  name={'CVC'}
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Campo obrigatório',
                                    },
                                  ]}
                                >
                                  <ReactInputMask
                                    mask={'999'}
                                    maskChar={''}
                                    maxLength={3}
                                    placeholder={'CVC'}
                                  >
                                    {(props) => <Input {...props} />}
                                  </ReactInputMask>
                                </Form.Item>
                              </Col>
                              <Col span={24}>
                                <Button
                                  block
                                  htmlType="submit"
                                  loading={this.state._loading}
                                  type="primary"
                                >
                                  Finalizar
                                </Button>
                              </Col>
                            </Row>
                          </Form>
                        </Collapse.Panel>
                        {/* <Collapse.Panel header="Pix" key={1}>
                          <Form onFinish={this.onSend}>
                            <Row gutter={[8, 0]}>
                              <Form.Item hidden initialValue="PIX" name="TYPE">
                                <Input value="PIX" />
                              </Form.Item>
                              <Col span={24}>
                                <Button
                                  block
                                  htmlType="submit"
                                  loading={this.state._loading}
                                  type="primary"
                                >
                                  Gerar pix
                                </Button>
                              </Col>
                            </Row>
                          </Form>
                        </Collapse.Panel>
                        <Collapse.Panel header="Boleto" key={2}>
                          <Form onFinish={this.onSend}>
                            <Row gutter={[8, 0]}>
                              <Form.Item
                                hidden
                                initialValue="BOLETO"
                                name="TYPE"
                              >
                                <Input value="BOLETO" />
                              </Form.Item>
                              <Col span={24}>
                                <Button
                                  block
                                  htmlType="submit"
                                  loading={this.state._loading}
                                  type="primary"
                                >
                                  Gerar boleto
                                </Button>
                              </Col>
                            </Row>
                          </Form>
                        </Collapse.Panel> */}
                      </Collapse>
                    </Card>
                  </Col>
                </Row>
              </Col>
            )}
          </Row>
        </Layout.Content>
      </Layout>
    );
  };
}

export default AdminAlterarPlanoCart;
